import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(() => ({
  link: {
    width: '100%',
  },
}));
